import { Mail, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/products";

export default function Suppliers() {
  return (
    <section id="suppliers" className="relative py-24 md:py-32 bg-[#071630] overflow-hidden" data-testid="suppliers-section">
      <img
        src="/assets/hero-editorial.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-[75%_center] opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#071630] via-[#071630]/90 to-[#071630]/50" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-[#5ec4bc] text-sm font-bold tracking-[0.25em] uppercase mb-3">Partnerships</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white mb-6" data-testid="suppliers-heading">
            Supplier Partnerships
          </h2>
          <p className="text-base md:text-lg text-[#c7d2e4] leading-relaxed mb-10" data-testid="suppliers-text">
            We invite suppliers of EDC toys, games, collectibles, video game consoles and hobby
            products to get in touch. Please send your company introduction, product catalogue and
            cooperation terms — we look forward to hearing from you.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="suppliers-email-btn"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#0d7a72] text-white font-bold text-sm tracking-wide hover:bg-[#0a5f59] transition-colors"
            >
              <Mail className="w-4 h-4" /> Email Us
            </a>
            <a
              href={`https://wa.me/${COMPANY.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="suppliers-whatsapp-btn"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/40 text-white font-bold text-sm tracking-wide hover:bg-white/10 transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
